module.exports = __webpack_public_path__ + "static/media/souleater.85d89d3c.jpeg";